import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

@Component({
  imports: [
    TranslateDirective
  ],
  selector: 'td-wb-page-header-date',
  templateUrl: 'page-header-date.component.html',
  styleUrls: ['page-header-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageHeaderDateComponent {
  @Input() date: string;
}
